$(document).ready(function(){

  // $(".customer-login").click(function(){
  //   window.location.href="/account/login";
  // });

  // $.get("https://ipinfo.io", function(response) {
  //   if (response.country == "IN") {
  //        window.location.href = "http://www.anshulimpex.com/";
  //   }
  // }, "jsonp");

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {

  
    if($(this).hasClass('active'))
    {
      $(this).toggleClass("active");
      $(this).next().css('max-height',0+'px');
    }
    else
    {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
    
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }
  });
};

$('.product-detail__thumbnail:first-child').each(function(){
  $('.product-detail__thumbnail').removeClass('thumb-active');
    $(this).addClass('thumb-active');
    $(this).trigger('click');
});

  $('.product-detail__thumbnails').slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    prevArrow: '<div class="slick-prev slick-arrow" aria-label="Previous" aria-disabled="false" style=""><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg></div>',
    nextArrow: '<div class="slick-next slick-arrow" aria-label="Next" aria-disabled="false" style=""><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path></svg></div>'
  });

  

  });
